import { Observable } from "rxjs";
import { Injectable, EventEmitter, Output } from "@angular/core";

import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { IContract } from "src/app/interfaces/contract";
import { IContractInfo } from "src/app/interfaces/contractInfo";
import { CommonHttpOption } from "./../../base/common-http-option";
import { HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class ContractService {
  @Output() change: EventEmitter<boolean> = new EventEmitter();

  constructor(private core: CoreService) { }

  list(filter, page: number = 1, pageSize: number = 10, header: HttpHeaders): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.list,
      header,
      new CommonHttpOption().paginator(page, pageSize, "ContractNumber", true)
        .append('Id', filter && filter.Id ? filter.Id : '')
        .append('ContractNumber', filter && filter.ContractNumber ? filter.ContractNumber : '')
        .append('FirstName', filter && filter.FirstName ? filter.FirstName : '')
        .append('LastName', filter && filter.LastName ? filter.LastName : '')
        .append('RoleName', filter && filter.RoleName ? filter.RoleName : '')
        .append('NationalCode', filter && filter.NationalCode ? filter.NationalCode : '')
        .append('ContractTypeId', filter && filter.ContractTypeId ? filter.ContractTypeId : '')
    );
  }

  getListPlacementInCompany(pageIndex: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)
    );
  }

  getContractInfo(data: IContractInfo): Observable<any> {
    return this.core.post(
      ServiceRoute.contract.getInfo,
      data,
      new CommonHttpOption().headers
    );
  }

  getType(): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.getType,
      new CommonHttpOption().headers
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: IContract): Observable<any> {
    return this.core.post(
      ServiceRoute.contract.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IContract): Observable<any> {
    return this.core.put(
      ServiceRoute.contract.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  editByHeader(data: IContract, header: HttpHeaders): Observable<any> {
    return this.core.put(
      ServiceRoute.contract.edit,
      data,
      header
    );
  }

  delete(data: any): Observable<any> {
    return this.core.delete(
      ServiceRoute.contract.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  setLeavingJobDate(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.contract.setLeavingJobDate,
      data,
      new CommonHttpOption().headers
    );
  }

  GetBranchThatUserHasContract(): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.GetContractBranchList,
      new CommonHttpOption().headers
    );
  }

  GetBranchContractUser(branchId: string): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.GetBranchContractUser + branchId,
      new CommonHttpOption().headers
    );
  }

  hasCurentUserTeacherContract(xCID: string): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.hasCurentUserTeacherContract + xCID,
      new CommonHttpOption().headers
    );
  }

  fire() {
    this.change.emit();
  }

  getListTeacherInBranch(
    data,
    page: number = 1,
    pageSize: number = 10
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.getListTeacherInBranch,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('FirstName', data && data.FirstName ? data.FirstName : '')
        .append('LastName', data && data.LastName ? data.LastName : '')
        .append('NationalCode', data && data.NationalCode ? data.NationalCode : '')
    );
  }

  getCompanyContractUser(): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.getCompanyContractUser,
      new CommonHttpOption().headers
    );
  }

  getListPlacementInBranch(
    BranchEncryptId: string,
    page: number = 1,
    pageSize: number = 10
  ): Observable<any> {
    return this.core.get(
      ServiceRoute.contract.getListPlacementInBranch + BranchEncryptId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getListLastContractSave(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.contract.getListLastContractSave,
      data,
      new CommonHttpOption().headers
    );
  }
}
